<ul>
  <li><a [routerLink]="'/events'" [routerLinkActive]="'app-menu-active'">{{ "menu.events" | translate }}</a></li>
  <li><a [routerLink]="'/users'" [routerLinkActive]="'app-menu-active'">{{ "menu.users" | translate }}</a></li>
  <li><a [routerLink]="'/lottery'" [routerLinkActive]="'app-menu-active'">{{ "menu.lottery" | translate }}</a></li>

  <li>
    <a [routerLink]="'/balloons'" [routerLinkActive]="'app-menu-active'">{{ "menu.balloons" | translate }}</a>
    <ul>
      <li>
        <a [routerLink]="'/balloons/print'" [routerLinkActive]="'app-menu-active'">{{ "menu.print" | translate }}</a>
      </li>
    </ul>
  </li>
</ul>
